<template>
  <anchor-modal
    light
    header-split
    body-classes="ma-0 pa-0"
    header-color="white"
    :max-width="maxWidth"
    :title="title"
    :loading="loading"
    :value="value"
    @input="val => $emit('input', val)"
  >
    <slot name="top-content" />
    <anchor-data-table
      fixed-header
      :height="tableHeight"
      :loading="loading"
      :headers="headers"
      :items="items"
      :sort-by="sortBy"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </anchor-data-table>
  </anchor-modal>
</template>

<script>
export default {
  name: 'AnchorModalTable',
  props: {
    loading: Boolean,
    items: Array,
    headers: Array,
    sortBy: Array,
    title: String,
    tableHeight: {
      type: [String, Number],
      default: '60vh',
    },
    maxWidth: {
      type: [String, Number],
      default: 1200,
    },
    value: undefined,
  },
};
</script>
